import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import clipboard from 'copy-to-clipboard';
import classnames from 'classnames';
import Icon from '../../wui-icon/src';
import ReactDOM from 'react-dom';
import Tooltip from '../../wui-tooltip/src';
import PropTypes from 'prop-types';
import { getComponentLocale } from '../../wui-locale/src/tool';
import i18n from './i18n.js';
import Modal from '../../wui-modal/src';
import FormControl from '../../wui-input/src';
import Button from '../../wui-button/src';
import { WebUI } from "../../wui-core/src/index.js"; //text和target都写的时候，target无效。 text的cut改为copy。
// target可以传css3选择器

var propTypes = {
  action: PropTypes.oneOf(['copy', 'cut', null]),
  text: PropTypes.string,
  success: PropTypes.func,
  error: PropTypes.func,
  locale: PropTypes.object
};
var defaultProps = {
  action: 'copy',
  text: '',
  target: '',
  success: function success() {},
  error: function error() {},
  locale: {}
};
var Clipboard = (_dec = WebUI({
  name: "clipboard",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Clipboard, _Component);

  var _super = _createSuper(Clipboard);

  function Clipboard(props, context) {
    var _this;

    _classCallCheck(this, Clipboard);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "copyHandle", function () {
      var _this$props = _this.props,
          action = _this$props.action,
          text = _this$props.text,
          target = _this$props.target,
          success = _this$props.success,
          error = _this$props.error;
      var copyContent = '';

      if (text) {
        copyContent = text;
        action = 'copy';
      } else {
        if (action === 'copy') {
          if (document.querySelector(target).tagName === 'INPUT' || document.querySelector(target).tagName === 'TEXTAREA') {
            copyContent = document.querySelector(target).value;
          } else {
            copyContent = document.querySelector(target).innerText;
          }
        } else {
          copyContent = document.querySelector(target).value;
          document.querySelector(target).value = '';
        }
      }

      try {
        if (clipboard(copyContent)) {
          _this.setState({
            currect: true,
            ready: true
          });

          if (success instanceof Function) success();
        } else {
          _this.setState({
            modalShow: true,
            html: copyContent
          });

          ReactDOM.findDOMNode(_this.text).select();
          if (error instanceof Function) error();
        }
      } catch (e) {
        _this.setState({
          modalShow: true,
          html: copyContent
        });

        ReactDOM.findDOMNode(_this.text).select();
        if (error instanceof Function) error(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.setState({
        currect: false,
        ready: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (e) {
      e.stopPropagation();

      _this.setState({
        modalShow: false
      });
    });

    _this.state = {
      currect: false,
      html: '',
      ready: false,
      modalShow: false
    };
    return _this;
  }

  _createClass(Clipboard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          clsPrefix = _this$props2.clsPrefix,
          action = _this$props2.action;
      var locale = getComponentLocale(this.props, this.context, 'Clipboard', function () {
        return i18n;
      });
      var tootipContent = locale[action];

      if (this.state.ready) {
        tootipContent = locale["".concat(action, "Ready")];
      }

      return /*#__PURE__*/React.createElement(Tooltip, {
        className: "".concat(clsPrefix, "-tooltip"),
        overlay: tootipContent,
        placement: "top"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.copyHandle,
        onMouseOut: this.blur,
        className: clsPrefix
      }, this.props.children ? this.props.children : /*#__PURE__*/React.createElement(Icon, {
        className: classnames({
          'uf-correct': this.state.currect,
          'uf-copy': !this.state.currect
        })
      }), /*#__PURE__*/React.createElement(Modal, {
        show: this.state.modalShow,
        onHide: this.close
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement(Modal.Title, null, " Ctrl+C ", locale['copyToClipboard'], " ")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(FormControl, {
        ref: function ref(el) {
          return _this2.text = el;
        },
        type: "text",
        readOnly: true,
        value: this.state.html
      })), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.close
      }, " ", locale['close'], " ")))));
    }
  }]);

  return Clipboard;
}(Component)) || _class);
;
Clipboard.propTypes = propTypes;
export default Clipboard;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-clipboard/src/Clipboard.js